import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const COINS = ["BTC", "ETH", "USDT", "USDC", "XRP", "SOL", "QNT"];

export const fetchTransfers = (minUsd) =>
  axios.get(`${API}/transfers`, { params: { min_usd: minUsd, limit: 200 } }).then((r) => r.data);
export const fetchStats = (minUsd) =>
  axios.get(`${API}/stats`, { params: { min_usd: minUsd } }).then((r) => r.data);
export const fetchSources = () => axios.get(`${API}/sources`).then((r) => r.data);
export const fetchSettings = () => axios.get(`${API}/settings`).then((r) => r.data);
export const saveSettings = (body) => axios.put(`${API}/settings`, body).then((r) => r.data);
export const sendTestAlert = () => axios.post(`${API}/alerts/test`).then((r) => r.data);
export const fetchKlines = (symbol, interval, cgId) =>
  axios.get(`${API}/klines`, { params: cgId ? { cg_id: cgId, interval } : { symbol, interval } }).then((r) => r.data);
export const fetchTokens = () => axios.get(`${API}/tokens`).then((r) => r.data);
export const addToken = (address) => axios.post(`${API}/tokens`, { address }).then((r) => r.data);
export const removeToken = (symbol) => axios.delete(`${API}/tokens/${symbol}`).then((r) => r.data);

export const fmtUsd = (v) => {
  if (v == null) return "—";
  const a = Math.abs(v);
  const s = v < 0 ? "-" : "";
  if (a >= 1e9) return `${s}$${(a / 1e9).toFixed(2)}B`;
  if (a >= 1e6) return `${s}$${(a / 1e6).toFixed(2)}M`;
  if (a >= 1e3) return `${s}$${(a / 1e3).toFixed(1)}K`;
  return `${s}$${a.toFixed(2)}`;
};

export const fmtAmt = (v) =>
  v >= 1000 ? Math.round(v).toLocaleString() : v.toLocaleString(undefined, { maximumFractionDigits: 2 });

export const shortAddr = (a) => (a ? `${a.slice(0, 6)}…${a.slice(-4)}` : "unknown");

export const timeAgo = (ts) => {
  const d = Math.max(0, Math.floor(Date.now() / 1000 - ts));
  if (d < 60) return `${d}s ago`;
  if (d < 3600) return `${Math.floor(d / 60)}m ago`;
  if (d < 86400) return `${Math.floor(d / 3600)}h ago`;
  return `${Math.floor(d / 86400)}d ago`;
};

export const DIRECTIONS = {
  inflow: { label: "INFLOW", hint: "Wallet → Exchange · dump risk", color: "#FF3D00" },
  outflow: { label: "OUTFLOW", hint: "Exchange → Wallet · accumulation", color: "#00E676" },
  wallet: { label: "WALLET", hint: "Wallet → Wallet", color: "#00E5FF" },
  exchange_to_exchange: { label: "EX→EX", hint: "Exchange → Exchange", color: "#FFB300" },
  exchange_internal: { label: "INTERNAL", hint: "Internal exchange move", color: "#64748B" },
};
